// @ts-expect-error Unfortunately atom isn't typed
import { atom, swap } from 'atom';
// Marking type as any for now, though should likely be of type ContentAssistanceSlashCommand
// from content-assistance-lib
export const hsContentAssistanceSelectedCommandAtom = atom(null);
export function setHsContentAssistanceCommand(command) {
  swap(hsContentAssistanceSelectedCommandAtom, () => command);
}